import * as R from 'unitx/ramda';
const animationRegistry = {};
export function registerAnimation(animationName, definition) {
  animationRegistry[animationName] = definition;
}
export function getAnimationConfigByName(animationName = '') {
  return animationRegistry[animationName];
}
export function getAnimationNames() {
  return Object.keys(animationRegistry);
}
export const initializeRegistryWithDefinitions = definitions => R.forEachObjIndexed((def, name) => registerAnimation(name, def), definitions);